import React, { useCallback, useEffect, useRef } from 'react';
import { usePartiesContext } from '../../context/PartiesContext';
import { PartiesItem } from './PartiesItem';

export const PartiesList = () => {
  const {
    listParties,
    handleGetListParties,
    setValues,
    showForm,
    isDeleteParty,
    isWithoutMainModal = false,
    isToTurnModal = false,
  } = usePartiesContext();
  const hasMountedRef = useRef(false);

  const getData = useCallback(async () => {
    setValues((prev) => ({ ...prev, loading: true }));
    try {
      await handleGetListParties();
    } finally {
      setValues((prev) => ({ ...prev, loading: false }));
    }
  }, [handleGetListParties, setValues]);

  useEffect(() => {
    if (!hasMountedRef.current) {
      return;
    }

    // Get parties whe close modal and after to delete party if isWithoutMainModal
    if (!isWithoutMainModal) return;
    if (!showForm && !isDeleteParty) {
      getData();
    }
  }, [showForm, isDeleteParty, isWithoutMainModal, getData]);

  useEffect(() => {
    // Load initial data
    hasMountedRef.current = true;
    getData();
  }, [getData]);

  if (!isToTurnModal && listParties.length === 0) {
    return (
      <div className="d-flex justify-content-center">
        <p className="h4 user-select-none">No hay partes registradas</p>
      </div>
    );
  }

  return (
    <>
      {!isToTurnModal &&
        listParties.map((party, index) => <PartiesItem key={index} party={party} />)}
    </>
  );
};
